import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { ContactFormContent,ContactFormForm } from './styles';

export function ContactForm() {
    const form = useRef<HTMLFormElement | null>(null);

    const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    
        emailjs.sendForm(
            'service_p10fqgm', 
            'template_n87w02k', 
            form.current!, 
            'UT9uQ91tz158jnV_V'
            ).then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          (e.target as HTMLFormElement).reset();
      };

    return (
        <ContactFormContent>
            <h3>Me fale sobre seu projeto</h3>
            <ContactFormForm ref={form} onSubmit={sendEmail}>
                    <div>
                        <label>Nome</label>
                        <input 
                            type="text" 
                            name="formName"
                            placeholder="Insira seu nome"
                        />
                    </div>
                    <div>
                        <label>Email</label>
                        <input 
                            type="email" 
                            name="formEmail"
                            placeholder="Insira seu email" 
                        />
                    </div>
                    <div>
                        <label>Whatsapp</label>
                        <input 
                            type="tel" 
                            name="formWhatsapp" 
                            placeholder="Insira seu whatsapp"
                        />
                    </div>
                    <div className="textarea">
                        <label>Porjeto</label>
                        <textarea 
                            name="FormProject"
                            placeholder="Descreva seu projeto"
                        ></textarea>
                    </div>
                    <button type="submit">
                        Enviar menssagem
                        <i className="uil uil-message"></i>
                    </button>
            </ContactFormForm>
        </ContactFormContent>
    )
}